import React from 'react';
import { SurveyItem, ItemData } from './SurveyItem';
import styles from '../../styles/components/survey-stack/SurveyStack.module.css';
interface StackData {
  items: ItemData[];
}
const SurveyStack: React.FC<StackData> = props => {
  const sortedItems = [...props.items].sort(
    (a, b) => b.updatedAt.getTime() - a.updatedAt.getTime()
  );
  return (
    <div className={styles.stackContainer}>
      {sortedItems.map((item, index) => (
        <SurveyItem key={index} {...item}></SurveyItem>
      ))}
    </div>
  );
};

export default SurveyStack;
